import React, { FC } from 'react';
import { Stack } from '@mui/material';

import { ChromeExtensionSection } from './ChromeExtensionSection';
import { MobileAppSection } from './MobileAppSection';

const ProductHubSection: FC = () => {
  return (
    <Stack gap={3} className="product-hub-section">
      <MobileAppSection />
      <ChromeExtensionSection />
    </Stack>
  );
};

export default ProductHubSection;
